export default "__VITE_ASSET__D87mRw6h__"